import { INavRoute } from 'app/components/'
import { LoggedInAppNavRoutes } from 'app/containers/RetirementApp/routes'
import { ActionCreator } from 'app/redux/ActionCreator'
import { ActionTypes, INavAction, INavState } from 'app/redux/Nav/reducer'

class NavActionCreator extends ActionCreator<INavState, INavAction> {
  private DefaultNavRoutes: INavRoute[] = []

  setDefaultNavRoutes(defaultNavRoutes: INavRoute[]) {
    this.DefaultNavRoutes = defaultNavRoutes
  }

  updateNavRoutes(NavRoutes: INavRoute[]) {
    const type = ActionTypes.UPDATE_NAV
    return this.dispatch({ type, NavRoutes })
  }

  showDefaultNavRoutes() {
    this.updateNavRoutes(this.DefaultNavRoutes)
  }

  updateHeader(status: string, statusClassName: string) {
    return this.dispatch({
      type: ActionTypes.UPDATE_HEADER,
      NavHeaderElement: { status, statusClassName }
    })
  }

  updateBreadcrumb(name: string, path: string) {
    const type = ActionTypes.UPDATE_BREADCRUMB

    return this.dispatch({ type, Breadcrumb: { name, path } })
  }

  removeBreadcrumb() {
    this.updateBreadcrumb(null, null)
  }

  showAdequateHeader() {
    return this.updateHeader('adequate', 'text-success')
  }

  showInadequateHeader() {
    return this.updateHeader('inadequate', 'text-danger')
  }
}

const NavActions = new NavActionCreator()

export {
  NavActions,
  NavActionCreator
}



// WEBPACK FOOTER //
// ./src/app/redux/Nav/actions/index.tsx